import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const PUT_EMPLOYEE_REQUEST = "PUT_EMPLOYEE_REQUEST";
export const PUT_EMPLOYEE_SUCCESS = "PUT_EMPLOYEE_SUCCESS";
export const PUT_EMPLOYEE_ERROR = "PUT_EMPLOYEE_ERROR";

//* ACTIONS ------------------------------------------------
export const putEmployeeRequest = (payload = {}, callback) => ({
  type: PUT_EMPLOYEE_REQUEST,
  payload,
  callback,
});

export const putEmployeeSuccess = () => ({
  type: PUT_EMPLOYEE_SUCCESS,
});

export const putEmployeeError = (error) => ({
  type: PUT_EMPLOYEE_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const putEmployeeServiceRequest = async ({ employeeId, formData }) => {
  console.log(employeeId, formData)
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data: formData,
  });

  return request(`/employees/${employeeId}`, options);
};
